/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Pending = 0, LinkOpened = 1, Accepted = 2
 */
export enum Routemize_Constants_InviteStatus {
    PENDING = 'Pending',
    LINK_OPENED = 'LinkOpened',
    ACCEPTED = 'Accepted',
}
